(function (root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.NSBusinessReadiness = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MODES = ['october', 'november', 'december', 'evergreen'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

  function normalizeCampaignMode(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return MODES.indexOf(normalized) >= 0 ? normalized : 'evergreen';
  }

  function normalizePriorities(values) {
    var seen = Object.create(null);

    return (Array.isArray(values) ? values : []).reduce(function (result, value) {
      var normalized = String(value || '').trim();
      if (!normalized || seen[normalized]) return result;
      seen[normalized] = true;
      result.push(normalized);
      return result;
    }, []);
  }

  function buildSummary(values) {
    var priorities = normalizePriorities(values);
    if (!priorities.length) {
      return 'No priorities selected yet. Choose the items that need review.';
    }

    if (priorities.length === 1) {
      return '1 review priority selected: ' + priorities[0] + '.';
    }

    return priorities.length + ' review priorities selected: ' +
      priorities.slice(0, -1).join(', ') + ' and ' + priorities[priorities.length - 1] + '.';
  }

  function parseUtm(value) {
    var result = { utm_source: '', utm_medium: '', utm_campaign: '' };

    try {
      var url = new URL(value);
      UTM_KEYS.forEach(function (key) {
        result[key] = url.searchParams.get(key) || '';
      });
    } catch (error) {
      return result;
    }

    return result;
  }

  function stripQuery(value) {
    try {
      var url = new URL(value);
      return url.origin + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function serializeContext(input) {
    var source = input || {};
    var utm = parseUtm(source.pageUrl || '');

    return {
      campaignMode: normalizeCampaignMode(source.campaignMode),
      priorities: normalizePriorities(source.priorities).join('; '),
      pageUrl: stripQuery(source.pageUrl || ''),
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign
    };
  }

  function selectedPriorities(documentRef) {
    var inputs = Array.prototype.slice.call(documentRef.querySelectorAll('[data-ns-br-priority]') || []);
    return inputs.filter(function (input) { return input.checked; }).map(function (input) {
      return input.getAttribute && input.getAttribute('data-ns-br-label') || input.value;
    });
  }

  function assignValue(node, value) {
    if (!node) return;
    node.value = value;
    if (node.type === 'hidden') node.defaultValue = value;
  }

  function init(documentRef, locationRef) {
    if (!documentRef || typeof documentRef.querySelector !== 'function') return;

    var assessment = documentRef.querySelector('[data-ns-br-assessment]');
    var hero = documentRef.querySelector('[data-ns-br-mode]');
    var summary = documentRef.querySelector('[data-ns-br-summary]');
    var currentUrl = locationRef && locationRef.href ? locationRef.href : '';

    function findField(fieldRoot, selector) {
      var scopedField = fieldRoot && typeof fieldRoot.querySelector === 'function'
        ? fieldRoot.querySelector(selector)
        : null;
      return scopedField || documentRef.querySelector(selector);
    }

    function update(fieldRoot) {
      var priorities = selectedPriorities(documentRef);
      var context = serializeContext({
        campaignMode: hero ? hero.getAttribute('data-ns-br-mode') : '',
        priorities: priorities,
        pageUrl: currentUrl
      });

      if (summary) summary.textContent = buildSummary(priorities);
      assignValue(findField(fieldRoot, '[data-ns-br-priorities]'), context.priorities);
      assignValue(findField(fieldRoot, '[data-ns-br-campaign]'), context.campaignMode);
      assignValue(findField(fieldRoot, '[data-ns-br-page-url]'), context.pageUrl);

      UTM_KEYS.forEach(function (key) {
        assignValue(findField(fieldRoot, '[data-ns-br-utm="' + key + '"]'), context[key]);
      });
    }

    if (assessment && typeof assessment.addEventListener === 'function') {
      assessment.addEventListener('change', update);
    }

    if (typeof documentRef.addEventListener === 'function') {
      documentRef.addEventListener('submit', function (event) {
        var form = event && event.target;
        if (!form || typeof form.querySelector !== 'function') return;
        if (form.id !== 'NSBusinessReadinessForm') return;
        update(form);
      }, true);
    }

    update();
  }

  var api = Object.freeze({
    normalizeCampaignMode: normalizeCampaignMode,
    normalizePriorities: normalizePriorities,
    buildSummary: buildSummary,
    parseUtm: parseUtm,
    serializeContext: serializeContext,
    init: init
  });

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document, window.location);
      }, { once: true });
    } else {
      init(document, window.location);
    }
  }

  return api;
});
